import { Reveal, SectionTitle, BrandButton } from "@/components/ui-bits";

export default function NGFilms() {
  return (
    <section id="ng-films" data-testid="section-ngfilms" className="py-24 sm:py-32 bg-[#F2EDE3]">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <Reveal>
          <SectionTitle tone="gray">NG Films</SectionTitle>
          <p className="mt-4 text-xl sm:text-2xl font-semibold text-[#6E6A66]">
            Nuestra base legal, creativa y financiera.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-8 space-y-5 text-base sm:text-lg leading-relaxed text-[#141414]/85">
            <p>
              Sabemos que una película no se sostiene solo con creatividad, sino
              también con planificación y gestión rigurosa. A través de la empresa se
              reciben los fondos, se gestionan y ejecutan los presupuestos, y se
              materializan las decisiones que sostienen el desarrollo de la película.
              Desde el desarrollo y la preproducción hasta el rodaje, la
              postproducción y la distribución, NG Films coordina al equipo, contrata
              proveedores y supervisa cada etapa del proceso, garantizando una
              ejecución eficiente, transparente y con resultados medibles.
            </p>
            <p>
              Cuidamos la confianza que recibimos para contar una historia que
              despierte conversaciones necesarias y nos ayude a crecer como sociedad.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-wrap gap-4">
            <BrandButton testid="ngfilms-linkedin" href="https://linkedin.com/company/ngfilms">
              Encuéntranos en LinkedIn
            </BrandButton>
            <BrandButton testid="ngfilms-contacto" variant="outline" href="mailto:belinda@ninagordita.pe">
              Contacto
            </BrandButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
